import React from 'react';

const prawnBorder =
  'https://santaplaya-bucket.s3.amazonaws.com/white_prawn_border.webp';

const EspecialidadesSection: React.FC = () => {
  return (
    <section className="relative w-full bg-sea py-12 px-4 lg:px-24">
      {/* Top Prawn Border */}
      <div className="flex justify-center my-24">
        <img
          src={prawnBorder}
          alt="Prawn Border"
          className="w-full max-w-6xl object-contain"
        />
      </div>

      <div className="max-w-4xl mx-auto text-center">
        {/* Section Title */}
        <h2 className="font-charles text-white text-5xl md:text-6xl mb-6">
          ESPECIALIDADES | SPECIALTIES
        </h2>

        {/* Tacos Subsection */}
        <div className="mb-24">
          <h3 className="font-charles text-basic text-3xl md:text-4xl mb-4 my-16">
            ALL TACOS ARE BAJA-STYLE
          </h3>
          <div className="flex flex-col md:flex-row justify-center items-center border-white py-12">
            {/* Taco Option: Fish */}
            <div className="px-4 flex-1">
              <p className="font-charles text-white text-2xl mb-1">Fish</p>
              <p className="font-bold text-white text-xl">$14</p>
            </div>
            {/* Vertical divider on md+ */}
            <div className="hidden md:block w-px bg-white h-24" />
            {/* Taco Option: Shrimp */}
            <div className="px-4 flex-1">
              <p className="font-charles text-white text-2xl mb-1">Shrimp</p>
              <p className="font-bold text-white text-xl">$16</p>
            </div>
            <div className="hidden md:block w-px bg-white h-24" />
            {/* Taco Option: Octopus */}
            <div className="px-4 flex-1">
              <p className="font-charles text-white text-2xl mb-1">Octopus</p>
              <p className="font-bold text-white text-xl">$16</p>
            </div>
          </div>
          {/* Taco Description */}
          <p className="font-prosto text-white text-lg mt-4">
            beer-battered and deep-fried with cabbage, pico de gallo, chipotle
            mayo, sour cream, and served on yellow corn tortillas (2).
          </p>
        </div>

        {/* Other Specialties */}
        <div>
          <div className="space-y-6">
            {/* Molcajete A La Cucaracha */}
            <div className="pt-4">
              <p className="font-charles text-white text-2xl mb-1">
                Molcajete A La Cucaracha
              </p>
              <p className="font-prosto text-basic text-lg mt-2">
                Cooked shrimp, octopus, clams, mussels, and snow crab legs
                topped with deviled sauce.
              </p>
              <p className="font-bold text-white text-xl">$32</p>
            </div>
            {/* Mojarra Frita */}
            <div className="pt-4">
              <p className="font-charles text-white text-2xl mb-1">
                Mojarra Frita — MP
              </p>
              <p className="font-prosto text-basic text-lg mt-2">
                Fried catch of the day with a side of rice and salad.
              </p>
            </div>
            {/* Salmon En Su Jugo */}
            <div className="pt-4">
              <p className="font-charles text-white text-2xl mb-1">
                Salmon En Su Jugo
              </p>
              <p className="font-prosto text-basic text-lg mt-2">
                Salmon topped with cream sauce, served with rice and salad.
              </p>
              <p className="font-bold text-white text-xl">$27</p>
            </div>
            {/* Carne En Su Jugo */}
            <div className="pt-4">
              <p className="font-charles text-white text-2xl mb-1">
                Carne En Su Jugo
              </p>
              <p className="font-prosto text-basic text-lg mt-2">
                Beef, potatoes, beans, and queso fresco.
              </p>
              <p className="font-bold text-white text-xl">$24</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Prawn Border */}
      <div className="flex justify-center my-24">
        <img
          src={prawnBorder}
          alt="Prawn Border"
          className="w-full max-w-6xl object-contain"
        />
      </div>
    </section>
  );
};

export default EspecialidadesSection;
